import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import placeholderSrc from "../placeholder"
import "./styles.scss";
import photo from "../../assets/photos/UNM_HS-Wellness_Art-Walk-2_WEB.jpg";
function SectionThree({ placeholderSrc }) {
  return (
    <div>
      <div className="tw-spacer tw-h-[6rem]"></div>
      <div className="tw-grid xl:tw-grid-cols-[95%_5%]">
        <div className="tw-grid xl:tw-grid-cols-1 ">
          <div className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-[40%_60%]">
            <div className="tw-grid tw-grid-cols-1 -tw-secondary-gradient-to-left tw-leading-[0px]">
              <div className="tw-relative">
                <LazyLoadImage
                  visibleByDefault={false}
                  alt="Horned Toad"
                  src={photo} // use normal <img> attributes as props
                  className="tw-relative w-[80%] lg:tw-w-[100%]"
                  placeholderSrc={placeholderSrc}
                />
                <div className="sectionNumber tw-absolute tw-font-extrabold xl:tw-text-[11.0rem] xl:tw-leading-[11.0rem] tw-block lg:tw-hidden">
                  3
                </div>
              </div>
              <div className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-[40%_60%]">
                <div className=" tw-hidden lg:tw-block tw-p-8"></div>
              </div>
            </div>
            <div className="tw-flex  tw-relative tw-bg-secondary">
              <div className="sectionNumber tw-absolute tw-font-extrabold xl:tw-text-[11.0rem] xl:tw-leading-[11.0rem] tw-hidden lg:tw-block">
                3
              </div>
              <div className="tw-flex ">
                <div className="tw-grid md:tw-grid-cols-1">
                  <div className="tw-flex tw-flex-cols tw-items-center lg:tw-p-0">
                    <div className="tw-grid  lg:tw-grid-cols-[5%_85%_10%] xl:tw-grid-cols-[5%_60%_15%]">
                      <div className="tw-hidden lg:tw-block"></div>
                      <div className="">
                        <div className=" tw-px-4 tw-py-0   tw-pt-8 tw-py-4 lg:tw-p-8 lg:tw-pt-8 tw-pb-2 lg:tw-pb-0 tw-mb-8">
                          <p className="tw-font-bold tw-italic tw-mb-4 tw-mb-0 tw-border-t-[1px] tw-border-white tw-pt-3 tw-text-2xl tw-w-1/2 tw-text-2xl tw-w-1/2">
                            Horned Toad
                          </p>
                          <p>
                            Just south of the College of Nursing/Pharmacy
                            building, this horned toad rests among the spiny
                            needles of a cactus garden. An evocative art piece
                            that reminds us that our campus is a part of the
                            Chihuahuan Desert.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default SectionThree;
